import React from 'react';

function ImagePreview() {
  const images = [
    {
      name: 'OG Image (Facebook/LinkedIn)',
      path: '/radio-solutions-og.png',
      size: '1200x630px',
      usage: 'Open Graph social sharing'
    },
    {
      name: 'Twitter Card',
      path: '/radio-solutions-twitter.png',
      size: '1200x600px',
      usage: 'Twitter social sharing'
    },
    {
      name: 'App Screenshot',
      path: '/screenshot.png',
      size: '1280x720px',
      usage: 'Schema.org structured data'
    }
  ];

  return (
    <div style={{ 
      padding: '40px', 
      maxWidth: '1400px', 
      margin: '0 auto',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      background: '#f5f5f5',
      minHeight: '100vh'
    }}>
      <h1 style={{ 
        color: '#6d28d9', 
        marginBottom: '30px',
        fontSize: '32px',
        fontWeight: '700'
      }}>
        🎨 SEO Images Preview
      </h1>

      {images.map((img, index) => (
        <div key={index} style={{
          background: 'white',
          padding: '30px',
          marginBottom: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <div style={{ marginBottom: '20px' }}>
            <h2 style={{ 
              color: '#111', 
              fontSize: '24px',
              fontWeight: '600',
              marginBottom: '8px'
            }}>
              {img.name}
            </h2>
            <div style={{ 
              color: '#666', 
              fontSize: '14px',
              display: 'flex',
              gap: '20px'
            }}>
              <span>📐 {img.size}</span>
              <span>🎯 {img.usage}</span>
            </div>
          </div>

          <div style={{
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            overflow: 'hidden',
            background: '#f9fafb'
          }}>
            <img 
              src={img.path} 
              alt={img.name}
              style={{ 
                width: '100%', 
                height: 'auto',
                display: 'block'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = `
                  <div style="padding: 40px; text-align: center; color: #ef4444;">
                    ❌ Image not found: ${img.path}
                  </div>
                `;
              }}
            />
          </div>

          <div style={{ 
            marginTop: '15px',
            padding: '12px',
            background: '#f0f9ff',
            borderRadius: '6px',
            fontSize: '13px',
            color: '#0369a1',
            fontFamily: 'monospace'
          }}>
            URL: {window.location.origin}{img.path}
          </div>
        </div>
      ))}

      <div style={{
        marginTop: '40px',
        padding: '20px',
        background: '#fef3c7',
        borderRadius: '8px',
        borderLeft: '4px solid #f59e0b'
      }}>
        <h3 style={{ color: '#92400e', marginBottom: '10px', fontSize: '18px' }}>
          📝 Οδηγίες Χρήσης
        </h3>
        <ul style={{ color: '#78350f', marginLeft: '20px', lineHeight: '1.8' }}>
          <li>Δεξί κλικ στην εικόνα → "Save Image As" για download</li>
          <li>Test στο Facebook: <a href="https://developers.facebook.com/tools/debug/" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>Sharing Debugger</a></li>
          <li>Test στο Twitter: <a href="https://cards-dev.twitter.com/validator" target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>Card Validator</a></li>
        </ul>
      </div>
    </div>
  );
}

export default ImagePreview;
